













































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import {timeSince} from '@/utils/time'
import {Getter, Action} from 'vuex-class'
import {IMessage, IRecipient, NoticeRespondAction} from '@/entities/notices'
import {respondToNotice} from '@/api/notices'
import AvatarOrInitials from '@/components/WebView/AvatarOrInitials.vue'
import FeedbackModal from '@/components/FeedbackModal.vue'
import NoticeTypeBadge from './NoticeTypeBadge.vue'
import {getJoinedRecipientNames} from '@/utils/notices'
import {ucwords, ucfirst} from '@/utils/string'
import BaseButton from '@/components/BaseButton.vue'
import TextWithHighlight from '@/components/TextWithHighlight.vue'
import confetti from '@/utils/fancyConfetti'
import {sleep} from '@/utils/async'
import Draggable from 'vuedraggable'
import {PredefinedNoticeTypes} from '@/utils/notices'
import { NOTICE_REACTION_TYPES } from '@/entities/notices'
import Quote from '@/components/Notices/Quote.vue'

const SWIPE_DISTANCE_TO_TRIGGER_RESPONSE = 50
// distance to ignore when dragged when a user accidentally drags while trying to click a button
const SWIPE_DISTANCE_TO_IGNORE = 5

@Component<NoticeTemplate>({
    components: {
        Draggable,
        BaseButton,
        TextWithHighlight,
        FeedbackModal,
        AvatarOrInitials,
        Loading,
        NoticeTypeBadge,
        Quote,
    },
    filters: {
        timeSince,
        ucwords,
        ucfirst
    }
})
export default class NoticeTemplate extends Vue {
    @Prop({type: Boolean, default: false}) public disableDrag!: boolean
    @Prop({type: Boolean, default: true}) private isReceiver !: boolean
    @Prop({type: String, default: ''}) private response ?: string
    @Prop({type: Number, default: 0}) private remainingNoticesCount ?: number
    @Prop({type: Object, default: {}}) private notice!: IMessage

    @Getter private recipients!: IRecipient[]

    @Action private loadRecipients

    private NOTICE_REACTION_TYPES = NOTICE_REACTION_TYPES
    private writingFeedback = false
    private feedbackComment = ''
    public drag = false
    public startPosX = 0
    public startPosY = 0
    public hideDraggedCard = false

    private mounted() {
        if (!this.recipients.length) {
            this.loadRecipients()
        }
    }

    private get NoticeRespondAction() {
        return NoticeRespondAction
    }

    private get noticeClassName() {
        return this.notice.type.replace(/\s/g, '');
    }

    private get noticeType() {
        return PredefinedNoticeTypes.find(noticeType => noticeType.name === this.notice.type)
    }

    private get allowedRespondAction() {
        const noticeType = this.noticeType
        return noticeType ? noticeType.allowedRespondActions : 0
    }

    private get showAddFeedback() {
        return this.allowedRespondAction & NoticeRespondAction.Feedback
    }

    private startDrag(e) {
        this.startPosX = e.originalEvent.clientX
        this.startPosY = e.originalEvent.clientY
        this.drag = true
    }

    private endDrag(e) {
        const endPosX = e.originalEvent.clientX !== undefined ? e.originalEvent.clientX : e.originalEvent.changedTouches[0].clientX
        const endPosY = e.originalEvent.clientY !== undefined ? e.originalEvent.clientY : e.originalEvent.changedTouches[0].clientY
        const dragDistanceX = this.startPosX - endPosX
        const dragDistanceY = this.startPosY - endPosY

        this.drag = false
        if (dragDistanceX >= SWIPE_DISTANCE_TO_TRIGGER_RESPONSE) {
            this.respond('down')
            this.hideDraggedCard = true
        } else if (dragDistanceX <= -SWIPE_DISTANCE_TO_TRIGGER_RESPONSE) {
            this.respond('up')
            this.hideDraggedCard = true
        } else if (dragDistanceX < SWIPE_DISTANCE_TO_IGNORE && dragDistanceX > -SWIPE_DISTANCE_TO_IGNORE && dragDistanceY < SWIPE_DISTANCE_TO_IGNORE && dragDistanceY > -SWIPE_DISTANCE_TO_IGNORE) {
            const object = document.elementFromPoint(endPosX, endPosY)
            if (object instanceof HTMLElement) {
                const action = object.dataset.action
                if (action !== undefined) {
                    return
                }
                if (action === 'feedback') {
                    this.writingFeedback = !this.writingFeedback
                    return
                }
                this.respond(action, '')
            }
        }
    }

    private async respond(action, feedback = '') {
        respondToNotice(this.notice.noticesrecipient_id, action, feedback)
        if (action === 'celebrate' || action === 'up') {
            await confetti.init('notice-stack-container', 1000)
            await confetti.start(1000, 1000, 1000)
            await sleep(3000)
        }
        this.$emit('respond', this.notice.id)
    }

    private onSubmitFeedback() {
        const feedback = this.feedbackComment
        this.$emit('read', {id: this.notice.id, feedback})
        this.respond('feedback', feedback)
    }

    public get sentTo() {
        return getJoinedRecipientNames(this.notice.recipients)
    }

    public get highlights() {
        return this.recipients.map((user) => `@${user.name}`)
    }

    get commentFontSize() {
        if (this.notice.message.length < 20) {
            return 52
        } else if (this.notice.message.length < 80) {
            return 24
        } else if (this.notice.message.length < 130) {
            return 20
        }
        return 13
    }
}
